import {FC, useCallback, useEffect, useMemo, useRef, useState} from "react";
import {
  IDataForSearchSidebar,
  IOpenSidebarWithTab,
  ITypeRadar,
} from "../../types";
import {ResultSearchContent, SearchResultBlock} from "../Sidebar/styles";
import IconToggleArrow from "../../assets/images/icon-toggle-arrow.svg";
import {SidebarTab} from "../Sidebar";
import {colors} from "../../mocks/projectsMock";
import {SearchInputCustom} from "../../ui/SearchInputCustom";
import {IClusterDataFromServer} from "../../pages/Dashboard/Dashboard.type";

interface IProps {
  typeRadar: ITypeRadar;
  setClosePanel: () => void;
  searchDatasidebarInfo?: IDataForSearchSidebar;
  openSidebarWithTab: IOpenSidebarWithTab;
  isOpenPanel?: boolean;
  allClusters?: IClusterDataFromServer[];
  onCloseSearchPanel: () => void;
}

export const SidebarSearchContainer: FC<IProps> = ({
  typeRadar,
  searchDatasidebarInfo: datasidebarInfo,
  openSidebarWithTab,
  isOpenPanel,
  allClusters,
  onCloseSearchPanel,
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [inputSearchValue, setInputSearchValue] = useState("");
  const [resultSearchFind, setResultSearchFind] = useState(
    {} as IDataForSearchSidebar
  );
  const [searchDatasidebarInfo, setSearchDatasidebarInfo] =
    useState<IDataForSearchSidebar>(
      datasidebarInfo || ({} as IDataForSearchSidebar)
    );
  const [technologiesToShow, setTechnologiesToShow] = useState(10);
  const [clustersToShow, setClustersToShow] = useState(10);
  const [weaksignalsToShow, setWeaksignalsToShow] = useState(10);
  const [checkClose, setCheckClose] = useState(false);
  const [showTechnologiesBlock, setShowTechnologiesBlock] = useState(true);
  const [showDirectionsBlock, setShowDirectionsBlock] = useState(true);
  const [showClustersBlock, setShowClustersBlock] = useState(true);
  const [showWeaksignalsBlock, setShowWeaksignalsBlock] = useState(true);

  const resultFind = useMemo(() => {
    return allClusters?.flatMap((cluster) =>
      (cluster.technologies || []).map((tech) => ({
        ...tech,
        cluster_id: cluster.documentId,
      }))
    );
  }, [allClusters]);

  useEffect(() => {
    const findFind = {
      ...datasidebarInfo,
      technologies:
        resultFind?.map((item) => {
          return {
            id: item.documentId,
            name: item.name,
            direction_id:
              datasidebarInfo?.clusters?.find((c) => c.id === item.cluster_id)
                ?.direction_id ?? "",
            cluster_id: item.cluster_id,
          };
        }) || [],
      directions: datasidebarInfo?.directions || [],
      clusters: datasidebarInfo?.clusters || [],
      weak_signals: datasidebarInfo?.weak_signals || [],
      trends: datasidebarInfo?.trends || [],
    };
    setResultSearchFind(findFind);
    setSearchDatasidebarInfo(findFind);
  }, [datasidebarInfo, resultFind]);

  let typeOpenCard: SidebarTab;
  let titleSearch = "";
  switch (typeRadar) {
    case "map":
      typeOpenCard = SidebarTab.CPU;
      titleSearch = "Кластеры";
      break;
    case "esg":
      typeOpenCard = SidebarTab.Projects;
      titleSearch = "Проекты";
      break;
    case "fintech":
      // if (!isWeak_signal) {
      //   typeOpenCard = SidebarTab.Trends;
      // } else {
      typeOpenCard = SidebarTab.Trends;
      titleSearch = "Тренды";
      // }
      break;
    case "stateInitiative":
      typeOpenCard = SidebarTab.StateInitiative;
      titleSearch = "Стейкхолдеры";
      break;
    default:
      typeOpenCard = SidebarTab.CPU;
      titleSearch = "Кластеры";
  }

  const handleClickOpenCLuster = (
    clusterId: number | string,
    clusterName: string,
    directionId: number | string
  ) => {
    onCloseSearchPanel();
    const directionTitle = searchDatasidebarInfo?.directions?.find(
      (item) => item.id === directionId
    )?.name;
    const segmentLabels =
      searchDatasidebarInfo?.directions &&
      searchDatasidebarInfo?.directions?.map((item) => {
        if (typeRadar === "stateInitiative") return item.documentId;
        return item.id;
      });
    const color = segmentLabels
      ?.map((item, i) => (item === directionId ? colors[i] : null))
      .find((item) => item !== null);
    openSidebarWithTab(
      typeOpenCard,
      directionId,
      clusterId,
      clusterName,
      directionTitle,
      color ?? undefined,
      undefined,
      undefined,
      typeRadar,
      true
    );
    setCheckClose(!checkClose);
  };

  const handleClickOpenTechnologie = (
    technologieId: number | string | undefined,
    technologieName: string,
    directionId: number | string,
    clusterId: number | string
  ) => {
    onCloseSearchPanel();
    const directionTitle = searchDatasidebarInfo?.directions?.find(
      (item) => item.id === directionId
    )?.name;
    const clusterTitle = searchDatasidebarInfo?.clusters?.find(
      (item) => item.id === clusterId
    )?.name;
    const segmentLabels =
      searchDatasidebarInfo?.directions &&
      searchDatasidebarInfo?.directions?.map((item) => {
        if (typeRadar === "stateInitiative") return item.documentId;
        return item.id;
      });
    const color = segmentLabels
      ?.map((item, i) => (item === directionId ? colors[i] : null))
      .find((item) => item !== null);
    // if (typeof technologieId === "number") {
    openSidebarWithTab(
      typeOpenCard,
      directionId,
      clusterId,
      clusterTitle,
      directionTitle,
      color ?? undefined,
      technologieName,
      technologieId,
      typeRadar,
      true
    );
    // }
    setCheckClose(!checkClose);
  };

  const handleClickOpenWeaksignal = (
    clusterId: number | string,
    clusterName: string,
    directionId: number | string
  ) => {
    onCloseSearchPanel();
    const directionTitle = searchDatasidebarInfo?.directions?.find(
      (item) => item.documentId === directionId
    )?.name;
    const segmentLabels =
      searchDatasidebarInfo?.directions &&
      searchDatasidebarInfo?.directions?.map((item) => {
        if (typeRadar === "stateInitiative") return item.documentId;
        return item.id;
      });
    const color = segmentLabels
      ?.map((item, i) => (item === directionId ? colors[i] : null))
      .find((item) => item !== null);
    openSidebarWithTab(
      SidebarTab.WeakSignal,
      directionId,
      clusterId,
      clusterName,
      directionTitle,
      color ?? undefined,
      undefined,
      undefined,
      "fintech",
      true
    );
    setCheckClose(!checkClose);
  };

  const handleClickOpenDirection = (
    directionId: number | string,
    directionName: string
  ) => {
    onCloseSearchPanel();
    const directionTitle = searchDatasidebarInfo?.directions?.find(
      (item) => item.id === directionId
    )?.name;
    const segmentLabels =
      searchDatasidebarInfo?.directions &&
      searchDatasidebarInfo?.directions?.map((item) => item.id);
    const color = segmentLabels
      ?.map((item, i) => (item === directionId ? colors[i] : null))
      .find((item) => item !== null);
    openSidebarWithTab(
      SidebarTab.Clusters,
      directionId,
      undefined,
      directionName,
      directionTitle,
      color ?? undefined,
      undefined,
      undefined,
      "map",
      true
    );
    setCheckClose(!checkClose);
  };

  const handleTypeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputSearchValue(event.target.value);
    setClustersToShow(10);
    setWeaksignalsToShow(10);
    setTechnologiesToShow(10);
  };

  const handleShowMoreTechnologies = () => {
    setTechnologiesToShow((prev) => prev + 10);
  };
  const handleShowMoreClusters = () => {
    setClustersToShow((prev) => prev + 10);
  };
  const handleShowMoreWeaksignals = () => {
    setWeaksignalsToShow((prev) => prev + 10);
  };

  useEffect(() => {
    const resultsFindTechnologies = searchDatasidebarInfo?.technologies?.filter(
      (item) => item.name.toLowerCase().includes(inputSearchValue.toLowerCase())
    );
    setResultSearchFind((prev) => ({
      ...prev,
      technologies: resultsFindTechnologies ?? [],
    }));
    const resultsFindClusters = searchDatasidebarInfo?.clusters?.filter(
      (item) => item.name.toLowerCase().includes(inputSearchValue.toLowerCase())
    );
    setResultSearchFind((prev) => ({
      ...prev,
      clusters: resultsFindClusters ?? [],
    }));
    const resultsFindDirections = searchDatasidebarInfo?.directions?.filter(
      (item) => item.name.toLowerCase().includes(inputSearchValue.toLowerCase())
    );
    setResultSearchFind((prev) => ({
      ...prev,
      directions: resultsFindDirections ?? [],
    }));
    if (typeRadar === "fintech" || typeRadar === "weak_signals") {
      const resultsFindWeaksignals =
        searchDatasidebarInfo?.weak_signals?.filter((item) =>
          item.name.toLowerCase().includes(inputSearchValue.toLowerCase())
        );
      setResultSearchFind((prev) => ({
        ...prev,
        weak_signals: resultsFindWeaksignals ?? [],
      }));
    }
  }, [inputSearchValue]);

  const toggleTechnologiesBlock = useCallback(() => {
    setShowTechnologiesBlock((prev) => !prev);
  }, [setShowTechnologiesBlock]);

  const toggleDirectionsBlock = useCallback(() => {
    setShowDirectionsBlock((prev) => !prev);
  }, [setShowDirectionsBlock]);

  const toggleClustersBlock = useCallback(() => {
    setShowClustersBlock((prev) => !prev);
  }, [setShowClustersBlock]);

  const toggleWeaksignalsBlock = useCallback(() => {
    setShowWeaksignalsBlock((prev) => !prev);
  }, [setShowWeaksignalsBlock]);
  return (
    <div
      style={{
        position: "absolute",
        left: 0,
        right: 0,
        top: 80,
        bottom: 0,
        border: "1px solid rgba(246, 251, 253, 0.28)",
        borderRadius: "0 0 12px 12px",
        backgroundColor: "#08090A",
        color: "rgba(255, 255, 255, 0.6)",
        overflow: "auto",
      }}
    >
      <SearchInputCustom
        searchInputRef={searchInputRef}
        inputSearchValue={inputSearchValue}
        handleTypeSearch={handleTypeSearch}
        setInputSearchValue={setInputSearchValue}
        isOpenPanel={isOpenPanel}
        isNoBorder={true}
      />
      {/* <div style={{padding: "0 1rem"}}>Результат:</div> */}
      {resultSearchFind?.clusters?.length > 0 ||
      resultSearchFind?.directions?.length > 0 ||
      (resultSearchFind?.technologies?.length ?? 0) > 0 ? (
        <div>
          {typeRadar === "map" && (
            <>
              <SearchResultBlock
                isShow={showTechnologiesBlock}
                onClick={toggleTechnologiesBlock}
              >
                <div className="titleBlock">
                  <img src={IconToggleArrow} alt="" />
                  <span>Технологии:</span>
                </div>{" "}
                <div className="countBlock">
                  {resultSearchFind?.technologies?.length ?? 0}
                </div>
              </SearchResultBlock>
              {showTechnologiesBlock && (
                <ResultSearchContent>
                  <div>
                    {resultSearchFind?.technologies
                      ?.slice(0, technologiesToShow)
                      .map((item) => (
                        <p
                          key={item.id}
                          onClick={() =>
                            handleClickOpenTechnologie(
                              item.id,
                              item.name,
                              item.direction_id,
                              item.cluster_id
                            )
                          }
                        >
                          {item.name}
                        </p>
                      ))}
                  </div>
                  {technologiesToShow <
                    (resultSearchFind?.technologies?.length ?? 0) && (
                    <span
                      style={{
                        color: "#0f9fff",
                        padding: "5px 10px",
                        cursor: "pointer",
                      }}
                      onClick={handleShowMoreTechnologies}
                    >
                      Показать еще
                    </span>
                  )}
                </ResultSearchContent>
              )}
            </>
          )}
          <SearchResultBlock
            isShow={showClustersBlock}
            onClick={toggleClustersBlock}
          >
            <div className="titleBlock">
              <img src={IconToggleArrow} alt="" />
              <span>{titleSearch}:</span>
            </div>
            <div className="countBlock">{resultSearchFind.clusters.length}</div>
          </SearchResultBlock>
          {showClustersBlock && (
            <ResultSearchContent>
              <div>
                {resultSearchFind.clusters
                  .slice(0, clustersToShow)
                  .map((item) => (
                    <p
                      key={item.id}
                      onClick={() =>
                        handleClickOpenCLuster(
                          item.id,
                          item.name,
                          item.direction_id
                        )
                      }
                    >
                      {item.name}
                    </p>
                  ))}
              </div>
              {clustersToShow < resultSearchFind.clusters.length && (
                <span
                  style={{
                    color: "#0f9fff",
                    padding: "5px 10px",
                    cursor: "pointer",
                  }}
                  onClick={handleShowMoreClusters}
                >
                  Показать еще
                </span>
              )}
            </ResultSearchContent>
          )}

          {typeRadar === "map" && (
            <>
              <SearchResultBlock
                isShow={showDirectionsBlock}
                onClick={toggleDirectionsBlock}
              >
                <div className="titleBlock">
                  <img src={IconToggleArrow} alt="" />
                  <span>Направления:</span>
                </div>{" "}
                <div className="countBlock">
                  {resultSearchFind.directions.length}
                </div>
              </SearchResultBlock>
              {showDirectionsBlock && (
                <ResultSearchContent>
                  <div>
                    {resultSearchFind.directions.slice(0, 10).map((item) => (
                      <p
                        key={item.id}
                        onClick={() =>
                          handleClickOpenDirection(item.id, item.name)
                        }
                      >
                        {item.name}
                      </p>
                    ))}
                  </div>
                </ResultSearchContent>
              )}
            </>
          )}

          {(typeRadar === "fintech" || typeRadar === "weak_signals") && (
            <>
              <SearchResultBlock
                isShow={showWeaksignalsBlock}
                onClick={toggleWeaksignalsBlock}
              >
                <div className="titleBlock">
                  <img src={IconToggleArrow} alt="" />
                  <span>Слабые сигналы:</span>
                </div>{" "}
                <div className="countBlock">
                  {resultSearchFind.weak_signals?.length}
                </div>
              </SearchResultBlock>
              {showWeaksignalsBlock && (
                <ResultSearchContent>
                  <div>
                    {resultSearchFind.weak_signals
                      ?.slice(0, weaksignalsToShow)
                      .map((item) => (
                        <p
                          key={item.id}
                          onClick={() =>
                            handleClickOpenWeaksignal(
                              item.id,
                              item.name,
                              item.direction_id
                            )
                          }
                        >
                          {item.name}
                        </p>
                      ))}
                  </div>
                  {resultSearchFind.weak_signals?.length &&
                    weaksignalsToShow <
                      resultSearchFind.weak_signals?.length && (
                      <span
                        style={{
                          color: "#0f9fff",
                          padding: "5px 10px",
                          cursor: "pointer",
                        }}
                        onClick={handleShowMoreWeaksignals}
                      >
                        Показать еще
                      </span>
                    )}
                </ResultSearchContent>
              )}
            </>
          )}
        </div>
      ) : (
        <div
          style={{
            padding: "5px 10px",
            borderBottom: "1px solid rgba(255,255,255,0.1)",
          }}
        >
          Ничего не найдено
        </div>
      )}
    </div>
  );
};
